import ImagePreview from "@/components/Common/ImagePreview/ImagePreview.vue";
import { createError } from "@/helpers/newsHelper";
import { updateLockingFile } from "../../../helpers/fileHelper";

export default {
  name: "EventFilePreview",
  extends: ImagePreview,
  data() {
    return {
      mainPeacock: "#00636C",
      mainRed: "#c55c52",
      mainGray: "#7a7a7a"
    };
  },
  methods: {
    createError,
    getFilePictureUrl(file) {
      return file?.picture?.url;
    },
    async updateFile(file) {
      await updateLockingFile(file.id, file.url, file.locked);
    }
  },
  computed: {
    generatedPictureUrl() {
      return this.fileToEdit?.picture?.url;
    },
    hasGeneratedPicture() {
      return this.generatedPictureUrl?.length;
    }
  }
};
